import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, inject } from '@angular/core';

import { reloadOnChunkLoadError } from './chunk-load-recovery';
import { LoadingService } from './loading.service';
import { LoggerService } from './logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logger = inject(LoggerService);
  private loadingService = inject(LoadingService);

  handleError(error: unknown): void {
    if (reloadOnChunkLoadError(error)) return;

    if (this.isHttpError(error)) {
      this.logger.error('HTTP error already handled by interceptor:', error);
      return;
    }

    this.logger.error('Runtime Error caught by GlobalErrorHandler:', error);

    const message = error instanceof Error ? error.message : 'Si è verificato un errore imprevisto.';
    this.loadingService.setError(message);
  }

  private isHttpError(error: unknown): boolean {
    if (error instanceof HttpErrorResponse) {
      return true;
    }

    if (error instanceof Error && error.cause instanceof HttpErrorResponse) {
      return true;
    }

    return false;
  }
}
